export var DisplayType;
(function (DisplayType) {
    DisplayType[DisplayType["AlwaysDisplay"] = 0] = "AlwaysDisplay";
    DisplayType[DisplayType["ConditionDisplay"] = 1] = "ConditionDisplay";
})(DisplayType || (DisplayType = {}));
